var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-target-rate"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.label)+" "),_c('span',[_vm._v(" "+_vm._s(_vm.target))])]),(_vm.isProgress)?_c('div',{staticClass:"c-progress",class:{
      'c-progress_lesszero': _vm.num < 0
    },style:({width: _vm.width})},[_c('c-progress',{attrs:{"height":_vm.height,"num":_vm.num}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }